<template>
    <div id="app">
        <the-notification />
        <the-modal />
        <router-view/>
    </div>
</template>

<script>
import TheNotification from '@/components/TheNotification'
import TheModal from '@/components/TheModal'
import localforage from 'localforage'

export default {
    components: {
        'the-notification': TheNotification,
        'the-modal': TheModal
    },
    metaInfo: {
        title: 'Dashboard',
        titleTemplate: process.env.VUE_APP_MODE === 'production' ?
            `%s - DailyFruits Delivery App` :
            `[${process.env.VUE_APP_MODE.toUpperCase()}] %s - DailyFruits Delivery App`
    },
    mounted(){
        window.addEventListener('offline', () => {
            this.$store.dispatch('addNotification', {
                type: 'warning',
                title: 'Brak połączenia',
                content: 'Połączenie internetowe zostało zerwane. Aplikacja przeszła w tryb offline.'
            })
        })
        window.addEventListener('online', () => {
            this.$store.dispatch('addNotification', {
                type: 'info',
                title: 'Połączenie przywrócone',
                content: 'Połączenie internetowe zostało przywrócone. Trwa synchronizacja danych.'
            })
            localforage.getItem('confirmations').then((confirmations) => {
                // get Deliveries only if there is no confirmations waiting to be synchronized
                // synchronizing confirmations will trigger 'fetchDeliveries' action
                if(confirmations === null){
                    this.$store.dispatch('fetchDeliveries')
                }
            })
        })
    }
}
</script>
